import { prop, compose } from 'ramda';

import { landing } from 'app/features/landing/selectors';
import { position } from 'app/analytics/selectors';
import translations from 'app/features/localization/translations.json';

const productComparison = compose(prop('productComparison'), landing);
const titleKey = compose(prop('titleKey'), productComparison);
const subtitleKey = compose(prop('subtitleKey'), productComparison);
const mangaAndStoreAvailabilityKey = compose(
  prop('mangaAndStoreAvailabilityKey'),
  productComparison,
);
const videoAvailabilityKey = compose(
  prop('videoAvailabilityKey'),
  productComparison,
);

const actionDetail = (state, props) => ({
  actionDetail: {
    position: position(state, props),
    textOfButtonOrLink: translations[props.textKey],
  },
});

export {
  titleKey,
  subtitleKey,
  mangaAndStoreAvailabilityKey,
  videoAvailabilityKey,
  actionDetail,
};
